import * as XLSX from 'xlsx';

const cellText = (cell: XLSX.CellObject | undefined): string => {
	if (!cell || cell.v == null) return '';
	if (cell.t === 'n' && typeof cell.v === 'number') {
		const isPercent = String(cell.z ?? '').includes('%') || /%\s*$/.test(cell.w ?? '');
		// toPrecision(12) drops float noise (0.01549 × 100 = 1.5489999999999999).
		return isPercent ? `${Number((cell.v * 100).toPrecision(12))}%` : String(cell.v);
	}
	return String(cell.w ?? cell.v).trim();
};

/**
 * A worksheet as a padded grid of strings, for importers that must find their own header
 * row in a hand-built workbook rather than assume row 1.
 *
 * Text cells keep their text. Numbers keep their STORED value: a percent-formatted cell
 * becomes `${value × 100}%`, because its display text is rounded to the cell's format —
 * 0.01366 under "0.00%" shows 1.37%, which is exactly the over-billing the six-decimal par
 * value exists to avoid.
 */
export const sheetCells = (ws: XLSX.WorkSheet): string[][] => {
	if (!ws['!ref']) return [];
	const range = XLSX.utils.decode_range(ws['!ref']);
	const out: string[][] = [];
	for (let r = range.s.r; r <= range.e.r; r++) {
		const row: string[] = [];
		for (let c = range.s.c; c <= range.e.c; c++) {
			row.push(cellText(ws[XLSX.utils.encode_cell({ r, c })]));
		}
		out.push(row);
	}
	return out;
};
